import React, { useState, useEffect } from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import withSharedSnackbar from "../../HOCs/withSharedSnackbar";
import { Dialog,  DialogTitle, DialogContent, DialogActions, TextField, Button, CircularProgress } from "@material-ui/core";

const GET_BRAND = gql`
  query GetBrand($id: Int!, $clientLoginId: Int!) {
    getBrand(id: $id, clientLoginId: $clientLoginId) {
      status
      message
      data {
        id
        name
      }
    }
  }
`;

const UPDATE_BRAND = gql`
  mutation UpdateBrand($id: Int!, $name: String!, $clientLoginId: Int!) {
    updateBrand(id: $id, name: $name, clientLoginId: $clientLoginId) {
      status
      message
      data {
        id
        name
      }
    }
  }
`;

const EditBrandModal = ({ 
  open, 
  onClose, 
  brandId, 
  clientLoginId, 
  updateBrand, 
  refetchBrands, 
  getBrandQuery ,
  openSnackbar
}) => {
  const [brandName, setBrandName] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    if (brandId && !getBrandQuery.loading && open && getBrandQuery.getBrand.data.length > 0) {
      setBrandName(getBrandQuery.getBrand.data[0].name);
    }
  }, [open, getBrandQuery]);

  const handleSave = async () => {
    if (!brandName.trim()) {
      setError("Brand name is required.");
      return;
    }

    setLoading(true);
    try {
      const { data } = await updateBrand({
        variables: { id: brandId, name: brandName, clientLoginId },
      });

      if (data.updateBrand.status) {
        refetchBrands();
        onClose();
        openSnackbar(`${data.updateBrand.message}`, { variant: "success" });
      } else {
        openSnackbar(`${data.updateBrand.message}`, { variant: "success" });
      }
    } catch (error) {
      openSnackbar("Brand update failed");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setBrandName("");
    setError("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleCancel} maxWidth="sm" fullWidth>
      <DialogTitle>Edit Brand</DialogTitle>
      <DialogContent>
        {loading ? (
          <CircularProgress />
        ) : (
          <div sx={{ mt: 2 }}>
            <TextField
              fullWidth
              label="Brand Name"
              variant="outlined"
              value={brandName}
              onChange={(e) => {
                setBrandName(e.target.value);
                setError("");
              }}
              error={!!error}
              helperText={error}
            />
          </div>
        )}
      </DialogContent>
      <DialogActions >
        <Button onClick={handleCancel}  variant="outlined" style={{
            borderColor: '#f44336',
            color: '#f44336',
            borderRadius: 8,
           
          }}>
          Cancel
        </Button>
        <Button onClick={handleSave} variant="contained" color="primary" disabled={loading} style={{
            backgroundColor: '#66bb6a', 
            color: '#ffffff',
            borderRadius: 8,
           
            '&:hover': {
              backgroundColor: '#81c784',
            },
          }}>
          Update
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default graphql(UPDATE_BRAND, { name: "updateBrand" })(
  graphql(GET_BRAND, {
    options: (props) => ({
      variables: { id: props.brandId, clientLoginId: props.clientLoginId },
      fetchPolicy: "network-only",

    }),
    skip: (props) => !props.brandId,
    props: ({ data }) => ({ getBrandQuery: data }),
  })(withSharedSnackbar(EditBrandModal))
);



// WEBPACK FOOTER //
// ./src/components/Pages/modalConfigure/EditBrandModal.jsx